module.exports = __webpack_public_path__ + "img/items-1.eba35cb.svg";